export const getClasses = (disabled, checked) => {
    return `mui-switch ${disabled? 'disabled' : ''} ${checked? 'checked' : ''}`;
} 